import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import CompleteProfile from '../pages/complete-profile/page';
import LoginDeviceSuccess from '../pages/device/success/page';
import NotFound from '../pages/error/not-found';
import Loading from '../pages/loading/loading';
import Login from '../pages/login/login';
import LoginRedirect from '../pages/login/redirect/page';
import Migration from '../pages/migration/page';
import MigrationSuccess from '../pages/migration/success/page';
import Root from '../pages/root';
import Page from './page';
import { RoutePath } from './router-config';
import MigrationAuth from '../pages/migration/auth/page';
var routes = [
    {
        component: _jsx(Root, {}),
        path: RoutePath.ROOT,
        pageKey: 'root',
    },
    {
        component: _jsx(Login, {}),
        path: RoutePath.LOGIN,
        pageKey: 'login',
    },
    {
        component: _jsx(LoginRedirect, {}),
        path: RoutePath.LOGIN_REDIRECT,
        pageKey: 'login-redirect',
    },
    {
        component: _jsx(LoginDeviceSuccess, {}),
        path: RoutePath.DEVICE_SUCCESS,
        pageKey: 'login-device-success',
    },
    {
        component: _jsx(CompleteProfile, {}),
        path: RoutePath.COMPLETE_PROFILE,
        pageKey: 'complete-profile',
    },
    {
        component: _jsx(Migration, {}),
        path: RoutePath.MIGRATION,
        pageKey: 'migration',
    },
    {
        component: _jsx(MigrationAuth, {}),
        path: RoutePath.MIGRATION_AUTH,
        pageKey: 'migration_auth',
    },
    {
        component: _jsx(MigrationSuccess, {}),
        path: RoutePath.MIGRATION_SUCCESS,
        pageKey: 'migration_success',
    },
];
export default function Router() {
    return (_jsx(Suspense, { fallback: Loading(), children: _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [routes.map(function (_a) {
                        var component = _a.component, path = _a.path, pageKey = _a.pageKey;
                        return (_jsx(Route, { element: _jsx(Page, { children: component, pageKey: pageKey }), path: path }, path));
                    }), _jsx(Route, { element: _jsx(Page, { children: _jsx(NotFound, {}), pageKey: "not-found" }), path: "*" })] }) }) }));
}
